import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AuthGuard from './components/Guards/GuardAuth';
import Error404 from './components/Layout/404/404';
import Menu from './components/Layout/Menu/Menu';
import Admin from './components/Layout/Admin/Admin';

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Página pública del menú */}
        <Route path="/" element={<Menu />} />

        {/* Panel de administración (pide login) */}
        <Route
          path="/admin"
          element={
            <AuthGuard>
              <Admin />
            </AuthGuard>
          }
        />

        <Route path="*" element={<Error404 />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
